import { NavigationMenuItem, NavigationMenuItemKey, PublicInvestmentOfferFlags } from './types'

const allMenuItems: Array<NavigationMenuItem> = [
  {
    key: 'description',
    path: 'beskrivelse',
    messageId: 'investmentOfferPage.nav.description',
    default: true,
  },
  {
    key: 'emission',
    path: 'emisjon',
    messageId: 'investmentOfferPage.nav.emission',
    submenu: [
      {
        hash: 'oversikt',
        messageId: 'ioInfoEmissionClient.navigation.overview',
        default: true,
      },
      {
        hash: 'selskap',
        messageId: 'ioInfoEmissionClient.navigation.companyInfo',
      },
      {
        hash: 'single-purpose-vehicle',
        messageId: 'ioInfoEmissionClient.navigation.singlePurposeVehicle',
        hide: (flags) => !flags.singlePurposeVehicleEnabled,
      },
      {
        hash: 'finansiell-informasjon',
        messageId: 'ioInfoEmissionClient.navigation.financialInfo',
      },
      {
        hash: 'kapitalutvidelse',
        messageId: 'ioInfoEmissionClient.navigation.emission',
      },
    ],
  },
  {
    key: 'discussion',
    path: 'diskusjon',
    messageId: 'investmentOfferPage.nav.discussion',
    hideInReadonly: true,
  },
  {
    key: 'teamAndOwners',
    path: 'team-og-eiere',
    messageId: 'investmentOfferPage.nav.teamAndOwners',
  },
  {
    key: 'documents',
    path: 'dokumenter',
    messageId: 'investmentOfferPage.nav.documents',
  },
  {
    key: 'subscriptionList',
    path: 'tegningsliste',
    messageId: 'investmentOfferPage.nav.subscriptionList',
    hideInReadonly: true,
  },
]

export const getMenuItems = (flags: PublicInvestmentOfferFlags) => {
  const list = allMenuItems.reduce<Array<NavigationMenuItem>>((acc, item) => {
    if (item?.hide?.(flags)) {
      return acc
    }
    if ('submenu' in item) {
      item.submenu = item.submenu.filter((obj) => !obj?.hide?.(flags))
    }
    return [...acc, item]
  }, [])
  return list
}

export const getSelectedMenuItem = ({
  menuItems,
  pathname,
}: { menuItems: Array<NavigationMenuItem>; pathname: string }) => {
  return menuItems.find((item) => pathname.includes(item.path)) || menuItems.find((item) => item.default)
}

export const getDefaultSubmenuItem = ({
  menuItems,
  key,
}: { menuItems: Array<NavigationMenuItem>; key: NavigationMenuItemKey }) => {
  const menuItem = menuItems.find((item) => item.key === key)
  return menuItem.submenu?.find((item) => item.default) || null
}

export const getSelectedSubmenuItem = ({
  menuItems,
  key,
  hash,
}: { menuItems: Array<NavigationMenuItem>; key: NavigationMenuItemKey; hash: string }) => {
  const menuItem = menuItems.find((item) => item.key === key)
  return menuItem.submenu.find((item) => hash.replace('#', '') === item.hash) || null
}
